import type { FlightFilterState } from '../filter_logic.js';
import type { FlightFilterCopy } from './filter_copy.js';
import { PanelSection } from './filter_panel_chrome.js';

/** Número do voo (#2110) — campo de texto, match exato tolerante a espaço e
 *  caixa (ver `matchesFlightNumber` no filter_logic). Fora do `filter_panel.tsx`
 *  pelo teto de linhas do arquivo. */
export function NumberSection({
  state,
  onPatch,
  copy,
}: Readonly<{
  state: FlightFilterState;
  copy: FlightFilterCopy;
  onPatch: (p: Partial<FlightFilterState>) => void;
}>) {
  return (
    <PanelSection label={copy.flightNumber.label}>
      <input
        className="ffp-numfield"
        type="text"
        value={state.flightNumber}
        placeholder={copy.flightNumber.placeholder}
        aria-label={copy.flightNumber.label}
        onChange={(e) => {
          onPatch({ flightNumber: e.target.value });
        }}
      />
    </PanelSection>
  );
}
